//  @flow

import React from 'react';
import Icon from '../../Components/Icon';
import ConatctForm from './ContactForm';

const AddressIcon = ({ icon, title, description }) => {
  return (
    <div className="address-icon-container">
      <div className="address-icon">
        <Icon className="address-icon-img" defaultIcon={icon} />
      </div>

      <div className="adress-details">
        <p className="adress-details-title">{title}</p>
        <span className="adress-details-description">{description}</span>
      </div>
    </div>
  );
};

const Banner = () => {
  return (
    <div className="contact-banner">
      <div className="contact-banner-icons">
        <AddressIcon icon="call" title="Phone" description="+91-9804636974" />
        <AddressIcon
          icon="mail"
          title="Email"
          description="educations@alienbrains.in"
        />
        <AddressIcon
          icon="pin"
          title="Location"
          description="CB - 28, CB Block, Sector-1, Saltlake City, Kolkata-64"
        />
      </div>

      <div className="contact-desktop-form">
        <ConatctForm className="contact-banner-form" />
      </div>
    </div>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/Pages/Contact/Banner.js